import * as z from 'zod/v4'

import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'

export const PersonSchema = buildEntrySchemaFor('person', {
  fields: z.lazy(() =>
    z.object({
      fullName: z.string(),
      position: z.string().optional(),
      photo: AssetSchema.optional(),
    }),
  ),
})

export type Person = z.infer<typeof PersonSchema>
